/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apartment_LoadingInputs */

const en_apartment_loading = /** @type {(inputs: Apartment_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading apartment…`)
};

/**
* | output |
* | --- |
* | "Loading apartment…" |
*
* @param {Apartment_LoadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const apartment_loading = /** @type {((inputs?: Apartment_LoadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apartment_LoadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_apartment_loading(inputs)
});